import React, { Component } from "react";
import { Modal, message, Form, InputNumber, Input, Icon, Button } from "antd";
import {
  CloseOutlined,
} from '@ant-design/icons';
import "./index.less"
class ServiceAgreement extends Component {
  state = {

  };
  render() {
    return (
      <Modal visible={this.props.visible} closable={false} centered={true} footer={null} width={1200} >
        <div className='serviceAgreement'>
          <div className='agreementHeader'>
            <span>轨迹查询服务用户协议</span>
            <CloseOutlined className='iconclose'  onClick={this.props.onCancel}/>

          </div>
          <div className='agreementBody'>
            <div>
              <p>
                为便于您使用平台联合第三方服务商及其平台推出的轨迹查询服务，您应当认真阅读并遵守本《轨迹查询服务用户协议》（“本协议”）以及数十方平台和三方平台发布的各项协议、规则、条款以及其他内容与文件。本协议是数通十方（深圳）数字科技有限公司（以下简称“数通十方”）作为数十方平台（定义见下文）的运营者和服务提供者，与您（“您”或“用户”）和您所代表的企业就注册、使用数十方及三方平台相应服务所订立的有效合约。
              </p>
              <p>
                您点击或勾选数十方平台和三方平台相关页面上的“同意”键或者以其他方式确认同意/接受本协议（如在相关页面上点击后续操作或已实际享有本协议项下的权益或已实际接受数十方平台和三方平台的服务或已实际执行本协议项下的部分约定等（“确认”），即表示您和您所代表的企业与数通十方公司和第三方服务商已达成协议并同意接受本协议全部约定内容的约束，并同意本协议以线上数据电文的形式订立。
              </p>
              <p>
                在确认本协议之前，请您务必审慎、仔细阅读并充分理解本协议的全部内容（特别是免除或者限制责任的内容、开通或使用某项服务的内容、收费的内容以及以粗体及/或下划线标注的内容），自行甄别判断，自担风险。如果您不同意本协议的任何内容，或者无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。本协议构成您和您所代表的企业注册、使用数十方及三方平台轨迹查询相关功能之先决条件，您的使用行为将视为同意接受本协议各项条款的约束。
              </p>
              <p>
                数通十方公司有权随时变更合作的第三方服务商和三方平台，有权随时变更本协议，上述变更将在数十方平台上予以公告，如您不同意相关变更，必须停止使用数十方平台。本协议内容包括协议正文及数十方平台和三方平台所有已经发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。一旦您继续使用数十方及三方平台，则表示您已接受并自愿遵守经修订后的条款。
              </p>
              <p>特别提示</p>
              <p>
                轨迹查询”页面及相关后续页面所呈现的内容和服务由上文所述第三方服务商云南拓芯物联网科技有限公司（以下简称“第三方服务商”）提供，您通过本页面提交及后续页面上传的资料信息和资料等相关数据，将被加密传输给第三方服务商，您将同时成为该第三方服务商的用户，后续相关的服务内容和质量均将由该第三方负责。
              </p>
              <p>
                数通十方公司仅就您与该第三方服务商通过数十方平台发生的数据和信息交换过程中的数据传输安全负责，后续相关服务的内容、质量将由第三方服务商负责，您对此认可并郑重承诺，在使用后续服务中可能产生的任何纠纷、责任，不向数通十方公司或数十方平台提出任何诉求或追究任何责任。
              </p>
              <p>
                您在填写和上传的内容中，如有涉及其他企业和/或人员的资料，应确保已经征得其同意或取得其授权，并将保守其秘密，承诺不利用工作之便收集、转卖、泄露资料和个人信息。
              </p>
            </div>
            <div className='block'>
              <p className='title'>一、定义</p>
              <p>
                1.1数通十方公司:指数通十方（深圳）数字科技有限公司，为数十方平台的开发、运营、维护主体。
              </p>
              <p>
                1.2数十方平台:指数通十方公司开发、运营、维护的产业互联网平台，包含采购、物流、租赁、咨询、管理及其他相关功能模块儿，包括但不限于网站、小程序、公众号、服务号、私有化部署的应用程序等载体。
              </p>
              <p>
                1.3第三方服务商:指与数通十方公司及/或数十方平台建立合作关系，为用户提供轨迹查询相关功能和服务的法人主体。本协议中特指云南拓芯物联网科技有限公司。
              </p>
              <p>
                1.4三方平台：指由第三方服务商负责运营的可供用户查询车辆位置和轨迹信息的软件/网站平台，包括但不限于APP、PC端、微信公众号、小程序等软件、网站、网页、程序。
              </p>
              <p>1.5平台：指数十方平台和/或三方平台，如无特殊说明，则同时指双方或任意一方。</p>
              <p>
                1.6平台方：指数通十方公司和/或第三方服务商，如无特殊说明，则同时指双方或任意一方。
              </p>
              <p>1.7用户：使用平台所提供的服务的货主、车主、企业及其他主体。</p>
              <p>1.8货主：指有货物运输需求的企业、其他法人组织、个体工商户、自然人等主体。</p>
              <p>
                1.9用户信息：指您提交给平台的及通过平台发布的及/或平台方通过您授权的第三方获取的用户相关信息，包括但不限于您提交、发布的您的基本信息、营业执照、用户指定的代表及/或联系人的姓名与联系方式、授权委托书、车辆行驶证、驾驶证、开户许可证、银行账户信息、用户的法定代表人/负责人/经营者/代表姓名、身份证号及身份证载明的其他信息等；姓名、电话号码、身份证号及身份证载明的其他信息、车辆信息等,以及您为申请、使用平台的合作方所提供的服务/商品而提交的其他用户相关信息。
              </p>
              <p>1.10个人信息：平台《隐私政策》下“个人信息”的定义和范围适用本协议。</p>
              <p>
                1.11账号：指您按平台提供的方式设置或取得的供您登录及使用平台服务的编码，该编码可能是您的手机号码/邮箱地址，也可以是根据平台规则编辑或设置的其他数字或文字。
              </p>
              <p>
                1.12司机：指具有依法经营货物运输业务相关资质的，能够提供货物运输服务的自然人，包括主驾和副驾（如有）。
              </p>
              <p>1.13车辆：指能够提供货物运输服务的货运车辆。</p>
              <p>
                1.14车辆信息：指您通过平台发布的与提供货物运输服务的司机和车辆相关的信息，包括但不限于司机身份证号、驾驶证、行驶证、车牌号码、车牌类型、车型、车长、车宽、载重、车辆识别代码、发动机号、车厢信息、车厢体积、车厢长度、拖挂轮轴、车辆轴数等信息。
              </p>
              <p>
                1.15货源信息：指您通过平台发布的与单次货物运输相关的信息，包括但不限于装货地点、送达地点、货物类型、装货时间、运输期限、货物重量、所需车辆规格等信息。
              </p>
              <p>
                1.16身份验证：指您在注册账号或开通、使用及/或接受平台的特定服务/商品的过程中，平台方及技术合作方根据本协议的约定对您提供的本人信息（包括但不限于您或您的法定代表人、负责人的姓名、身份证号、身份证所载明的其他信息、照片等身份信息和您的即时脸部图像，具体以平台方或其技术合作方要求为准，统称为“验证信息”）及验证信息凭证的真实性、准确性及/或一致性进行验证的过程，验证的方式与流程由平台方及/或其技术合作方指定。该等验证信息及验证信息凭证经身份验证被确认为真实、准确及一致的，视为您通过了身份验证。
              </p>
              <p>
                1.17验证信息凭证：指验证信息的一切载体，包括但不限于载有、证明、体现、反映验证信息的各类文件、资料、凭据、凭证、证件、证照、图片、照片、视频等。
              </p>
            </div>
            <div className='block'>
              <p className='title'>二、用户资格</p>
              <p>2.1您向平台方申请使用平台服务应当首先注册成为平台的用户，成为用户应具备以下条件：</p>
              <p>
                （1）若您为企业、其他法人组织或个体工商户，您必须是经过相关法律法规合法注册且有效存续，具有完全的民事行为能力和民事权利能力，具备就您所从事的经营活动及/或其他活动依法承担民事责任的能力，且具有良好的信誉。
              </p>
              <p>
                （2）若您为自然人，您必须年满十八周岁，并具有完全的民事行为能力和民事权利能力。若您不具备前述民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
              </p>
              <p>
                （3）您一直按照所有对您适用的法律法规的规定开展经营活动及/或其他活动，不存在违法违规的行为及/或情形。
              </p>
              <p>
                （4）如您提供货物运输服务，您应具备包括但不限于《道路运输经营许可证的》等资质、证照及从事货物运输服务的必要的法律手续和合法依据。
              </p>
              <p>
                （5）若您通过平台查询车辆信息，则您应确保您对被查询的车辆拥有合法占有、使用、监督的权利，且车辆处于合法状态和正常营运及使用状态。
              </p>
            </div>
            <div className='block'>
              <p className='title'>三、用户的账号、密码及验证信息</p>
              <p>3.1您一旦在平台成功注册为用户，将得到一个账号和密码。</p>
              <p>
                3.2您应自行设置账号的密码，并予以妥善保管，不得以任何形式擅自转让或授权他人使用您的账号和密码，否则您应当承担由此产生的全部责任，平台方保留拒绝提供相应服务、冻结或收回注册账号或终止本服务协议的权利，并可要求您对平台方及关联方所承受的损失予以赔偿。
              </p>
              <p>
                3.3在您注册平台用户或开通、使用、接受平台的服务及/或用户/会员资格的过程中，您应按平台的要求提供真实、准确、完整且有效的个人信息。平台及其合作方有权根据本协议及平台其他规则要求您提供验证信息及验证信息凭证，并对您的验证信息和验证信息凭证的真实性、准确性及/或一致性进行验证，您应积极配合，否则平台有权限制或停止向您提供部分或全部平台服务。
              </p>
              <p>
                3.4若因国家法律法规、部门规章、监管机构的要求或平台经营需要，需要您补充提供任何验证信息及验证信息凭证时，如您不能及时提供，平台有权立即暂停或终止向您提供部分或全部服务。
              </p>
              <p>
                3.5您应保证您所填写及提供的用户信息、用户信息凭证、验证信息、验证信息凭证、联系电话、联系地址、电子邮件地址等资料、凭证、信息的真实性、准确性、完整性及有效性，同时也有义务在相关资料、凭证、信息发生变更时及时通知平台进行更新。您了解并同意，您有义务持续确保您提供的相关资料、凭证、信息的真实性、完整性及有效性。若您提供任何错误、不实、不准确、过时或不完整资料、凭证、信息，或平台有合理理由怀疑该资料、凭证、信息为错误、不实、不准确、过时或不完整的，平台有权立即暂停或终止对您提供服务，或限制您平台账号的部分或全部功能，平台对此不承担任何责任，您将承担因此而产生的全部直接或间接损失，同时，您还应当赔偿平台及/或任何其他第三方因此遭受的全部损失。
              </p>
              <p>3.6您应妥善保管下列信息、资料和硬件设备：</p>
              <p>（1）账号及其密码；</p>
              <p>（2）银行卡及其密码、CVV码、有效期等卡片信息；</p>
              <p>（3）手机等您用于登陆账号及/或使用平台的硬件设备及SIM卡信息；</p>
              <p>（4）您授权/指定的代表的人脸信息、指纹信息等生物识别信息。</p>
              <p>
                您应妥善保管上述资料、信息和硬件设备，并确保您的手机等移动终端设备在安全、无病毒、未被入侵、未被监控、未被非法控制的环境下运行和使用。
              </p>
              <p>
                若您泄露了上述信息中的任意一项或遗失了上述硬件设备，或您遭受他人攻击、诈骗等损害，由此导致的风险和损失应由您自行承担。
              </p>
              <p>3.7发生下列任一情形时，您应及时联系三方服务商的客服部门，以减少可能发生的损失：</p>
              <p>（1）您不慎遗失或泄露了本协议第3.6条所列信息的；</p>
              <p>（2）您遗失了您的手机等移动终端或SIM卡的；</p>
              <p>（3）您在开设银行账户时预留了他人的手机号码的；</p>
              <p>（4）第三人冒用或盗用您的验证信息、验证信息凭证或账户信息的；</p>
              <p>
                （5）其他任何未经您本人合法授权，却在使用您的账号、本服务或您的银行账户的情况及/或您的账户有其他安全漏洞的情况。
              </p>
              <p>
                如发生上述情形，请及时拨打三方服务商客服电话。若您未及时通知三方服务商而导致损失形成或扩大的，您应自行承担因此遭受的损失。您理解三方服务商对您的任何请求会要求您提供必要、充分的说明与证据并进行必要的验证，且其采取行动需要合理时间，其不确保应您请求而采取的行动能够避免或阻止侵害后果的形成或扩大，其对您发生上述情形而遭受的损失不承担责任。
              </p>
              <p>
                3.8您在此不可撤销地同意并授权：（1）在您需通过三方平台支付任何款项时，由第三方服务商及/或三方平台合作的银行及/或第三方支付机构（合称“支付机构”）根据您发出的指令代您扣划银行卡（需绑定）账户、微信账户、支付宝账户或第三方支付机构为您开立的钱包账户（包括但不限于由第三方服务商合作的第三方支付机构为您开立并在三方平台相关页面进行显示的钱包账户）等其他账户中的款项，并代为将所扣划的款项用于向您的交易相对方进行结算；（2）若由支付机构代为扣划的，根据支付机构要求，您需在支付机构开立支付账户的，您在此不可撤销的授权并同意，第三方服务商将您的相关信息提供给该支付机构，由其为您开立支付账户；（3）在您需通过三方平台收取任何款项时，由第三方服务商合作的银行或支付机构代您收取该等款项，且在您需提取/使用该等款项并履行了银行、支付机构要求的必要的手续（包括但不限于按支付机构的要求绑定银行卡并完善相关信息）后，由第三方服务商合作的银行或支付机构向您结算或为您扣划该等款项；（4）第三方服务商及三方平台有权根据您通过银行或支付机构的服务支付、收取及/或提现的款项金额实时记录、留存及/或通过三方平台及相关页面(如“余额”页面、“钱包”页面)向您显示您的交易信息及在支付机构留存的款项金额变动信息，但您确认并同意，第三方服务商及三方平台均不向您提供任何支付服务，上述所有与支付、金额等相关的信息最终由提供支付服务的支付机构向您负责，第三方服务商及三方平台均不就该等信息的真实性、准确性、完整性与有效性负责。就绑定银行卡，您应确保合法地享有使用所绑定银行卡及该银行卡内资金的权利，未侵犯任何第三方的合法权益，否则因此造成损失的，您应负责赔偿并承担全部法律责任。
              </p>
            </div>
            <div className='block'>
              <p className='title'>四、账户的操作</p>
              <p>若您为企业或其他法人组织的，您需要：</p>
              <p>
                4.1在申请注册平台用户之前，您应向平台方出具《授权委托书》，指定账号操作人。账号操作人持有您的平台账户及密码。
              </p>
              <p>
                4.2无论您是否指定账号操作人及/或出具《授权委托书》，您应理解，平台方就您与您的账号使用人/操作人之间的关系不具有任何核查的义务，您应自行妥善保管账号密码，任何使用您的账号密码登录使用平台服务的行为均视同您的行为，由此产生的风险、责任与法律后果由您承担。如因您与您的账号使用人/操作人之间的纠纷或争议导致给平台方或其他任何第三方造成侵权或损失的，您与您的账号使用人/操作人应当承担连带赔偿责任，平台方因此而遭受了损失的，有权向您直接追偿。
              </p>
            </div>
            <div className='block'>
              <p className='title'>五、用户权利与义务</p>
              <p>若您为企业或其他法人组织的，您需要：</p>
              <p>
                5.1您应根据本协议及平台发布的其他相关协议、规则，使用平台提供的功能与服务，包括但不限于在平台上查询车辆实时和历史位置信息、查询车辆实时和历史轨迹信息、使用平台上的增值服务、参加平台的有关活动及/或享受平台提供的其他有关资讯及信息服务等（统称“平台服务”或“本服务”）。但对于平台提供的会员服务等付费服务，平台有权根据服务类型及服务阶段确定不同的资费标准和收费方式，可能会给予您一定免费体验付费服务的次数或期限，也有权根据运营需要或您的使用情况随时终止您的免费体验，免费体验终止后您须按平台页面显示的资费标准、收费方式、购买方式等资费政策信息购买付费服务后方能继续使用。
              </p>
              <p>5.2您使用平台服务的，必须自行准备如下设备和承担如下开支：</p>
              <p>（1）上网设备，包括但不限于电脑、手机或者其他上网终端及其他必备的上网装置；</p>
              <p>（2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</p>
              <p>
                5.3您不得使用以下方式登录平台或破坏平台所提供的服务，由此造成平台方或第三方损失的，您应当承担全部赔偿责任：
              </p>
              <p>（1）以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录平台；</p>
              <p>（2）通过任何方式对平台结构造成或可能造成不合理或不合比例的重大负荷的行为；</p>
              <p>（3）通过任何方式干扰或试图干扰平台的正常工作或平台上进行的任何活动。</p>
              <p>
                5.4您知晓并同意平台合作、指定或认可的第三方征信机构有权基于提供信用或风控服务的需要，向合法保存有您的信息的机构（包括但不限于平台）采集相应信息，用于验证您的信息的真实性及风险判断使用，并将上述分析结果提供给平台方。
              </p>
              <p>
                5.5您理解并同意：为向您提供更为细致、贴心的服务，在经过您的事先确认后，平台授权、认可的第三方商家、广告商可能通过您注册时填写的手机号码或者电子邮箱向您发送您可能感兴趣的商品服务的广告宣传信息、促销优惠等商业性信息；如果您不愿意接收此类信息，则您有权通过平台提供的相应的退订方式进行退订。您理解并同意，对上述的相关广告信息，您应审慎判断其真实性和可靠性。在根据广告信息需要交易之前，您应当向平台进行确认，否则您应对依该广告信息进行的交易负责，平台方对此不承担任何责任。
              </p>
            </div>
            <div className='block'>
              <p className='title'>六、用户行为规范</p>
              <p>6.1您同意并保证，作为平台的用户，您应严格履行如下约定：</p>
              <p>（1）您应本着“遵纪守法”的原则严格遵守所在国家或地区的法律法规及相关规定。</p>
              <p>
                （2）您应本着“审慎交易”的原则了解并遵守本协议项下及平台的所有规则以及社会公共利益、公共道德。
              </p>
              <p>
                （3）您应本着“诚实信用”的原则使用平台服务，不得通过虚构事实、伪造证据、与他人串通等手段，侵害平台方及其他第三方的权益。
              </p>
              <p>6.2您同意并保证，作为平台的用户，您应严格遵守以下义务：</p>
              <p>（1）不得传输、发表及/或传播含有下列内容的信息：</p>
              <p>反对宪法所确定的基本原则;</p>
              <p>煽动抗拒、反对或破坏宪法和法律、行政法规实施；</p>
              <p>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
              <p>损害国家荣誉和利益的；</p>
              <p>煽动民族仇恨、民族歧视，破坏民族团结的；</p>
              <p>破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
              <p>散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
              <p>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
              <p>侮辱或者诽谤他人，侵害他人合法权益的；</p>
              <p>含有法律、行政法规及/或其他国家有关规定禁止的其他内容的。</p>
              <p>（2）从中国大陆向境外传输资料信息时必须符合中国有关法律法规；</p>
              <p>（3）不得利用平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</p>
              <p>（4）不得干扰平台的正常运转，不得侵入平台及国家计算机信息系统；</p>
              <p>
                （5）不得传输、发表及/或传播任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、诽谤性的、恐吓性的、歧视性的、伤害性的、庸俗的、不文明的、虚假的及其他违反公序良俗的信息资料；
              </p>
              <p>6）不得传输、发表及/或传播损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>
              <p>（7）不得教唆他人从事本条所禁止的行为；</p>
              <p>
                （8）不得在平台任何页面（包括但不限于评论、社区）发布任何形式的营销广告，或类似的营销信息、垃圾信息；
              </p>
              <p>
                （9）您账户内的任何优惠信息（包括但不限于积分、优惠券及其他形式优惠或折扣等）您仅在使用平台相关服务时享有使用权，严禁利用上述优惠信息进行其他经营性行为；
              </p>
              <p>
                （10）您不得利用任何非法手段获取其他用户个人信息，不得将其他用户信息用于任何营利或非营利目的，不得泄露其他用户或权利人的个人隐私，否则平台方有权采取本协议规定的合理措施制止您的上述行为，情节严重的，将提交公安机关进行刑事立案；
              </p>
              <p>
                （11）您不得发布任何侵犯他人著作权、商标权等知识产权或其他合法权利的内容；如果平台或其他用户或权利人发现您发布的信息涉嫌侵犯他人知识产权或其他合法权益的，平台有权立即删除您发布的信息，或者采取其他必要措施予以制止；
              </p>
              <p>
                （12）您应不时关注并遵守平台不时公布或修改的各类规则规定。平台保有删除各类不符合法律政策或不真实的信息内容而无须通知您的权利；
              </p>
              <p>
                6.3若您未遵守本协议的任何约定、用户行为规范、平台公布的其他规则、规范及/或您在平台确认/签署的其他协议、文件的，平台方有权做出独立判断并立即采取停止传输、消除信息、限制/取消您的权限、版块、暂停、封禁或关闭您的账号、冻结您平台账户内余额、关闭相应交易、暂停、限制您使用的服务、保存有关记录、向国家有关机关报告等措施。您须对自己在网上的言论和行为承担法律责任，如您的行为导致任何法律后果的发生，您应以自己的名义独立承担相应的法律责任，如给平台方造成任何损失的，则您应立即足额赔偿平台方的全部直接与间接损失。
              </p>
            </div>
            <div className='block'>
              <p className='title'>七、平台服务费用及其他费用</p>
              <p>
                7.1当您申请获得平台会员资格及/或使用需付费的平台服务时，平台方有权向您收取相关会员服务费及其他平台服务费用（合称“平台服务费用”）。各项平台服务费用详见您使用平台服务时，平台上所列之收费说明及收费标准。平台方保留单方面制定及调整平台服务费用收费标准的权利。
              </p>
              <p>
                7.2您在使用平台服务过程中可能需要向第三方（如银行、支付机构或提供技术服务的第三方等）支付一定的第三方服务费用（“第三方服务费用”），具体费用名称及收费标准详见平台的提示及收费标准。您需按平台的操作引导进行支付，您同意将根据上述收费标准自行或委托平台方或其合作方代为向第三方支付该等服务费。
              </p>
              <p>
                7.3若您不同意支付上述平台服务费用及/或第三方服务费用的，则您将无法使用平台所有付费功能/服务。您若需要获取、使用相关功能/服务的，请先提前了解清楚关于该服务的收费标准、方式等信息。
              </p>
              <p>
                7.4你确认，您使用平台服务系为开展商业运营并以获取运营收入为目的，您认可平台服务所具有的经济价值并已充分理解本协议中有关平台服务费用及其他费用的收费约定（“收费约定”），且您已基于独立、理性的商业判断而选择同意接受本协议项下的收费约定。您在此不可撤销地确认并同意，本协议中的收费约定代替平台方及其关联方在线上及/或线下曾向您作出及/或出具的有关免费、不收费及/或其他与收费约定存在冲突的所有书面以及口头的宣传文件、承诺、函件、文件等（如有）。
              </p>
            </div>
            <div className='block'>
              <p className='title'>八、终止服务的特别约定</p>
              <p>8.1如果您有下列情形发生，平台方有权终止您使用平台：</p>
              <p>
                （1）您违反相关法律法规，具有非法目的或利用本协议项下的安排实施侵害他人合法权益的行为；
              </p>
              <p>
                （2）您提供虚假注册信息，或存在通过虚构事实、伪造证据、发布虚假信息、与第三方串通等手段，侵害平台方及/或其他第三方权益的情形的；
              </p>
              <p>
                （3）您严重违反本协议及平台公布的其他规则，平台方有权依据本协议收回、注销用户账号，此情形下，本协议于账号收回、注销之日终止；
              </p>
              <p>
                （4）在满足平台公示的账号注销条件时，您通过网站自助服务或第三方平台的客服注销三方平台的用户账号，本协议于账号注销之日终止；
              </p>
              <p>
                （5）平台方有权根据自身商业安排经过合理的提前通知终止平台的所有服务，本协议于平台全部服务依法定程序及方式终止之日终止。
              </p>
              <p>
                8.2本协议的终止不影响本协议终止前各方的相关权利和义务，包括但不限于守约方依据本协议向违约方追究相应的违约责任。
              </p>
              <p>
                8.3本协议终止后，对于您在本协议存续期间产生的交易订单，您可与交易相对方协商是否继续履行，并向平台提交您与交易相对方就此达成的双方签字和/或盖章的书面协议。否则，平台可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单，且赔偿由此造成平台的一切损失；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
              </p>
              <p>
                8.4您理解并同意，在您注销前您已认真阅读、认可平台方《隐私政策》及《账户注销须知》，并已了解、同意相关用户注销流程及注销后的权利义务安排；平台方将按照《隐私政策》及《账户注销须知》的规定处理您的个人信息。
              </p>
            </div>
            <div className='block'>
              <p className='title'>九、平台方的其他权利及义务</p>
              <p>9.1平台方设立业务咨询和投诉电话，负责解答您在履行本协议过程中遇到的各种疑问。</p>
              <p>
                9.2您了解并同意，平台方有权应国家有权机关（包括但不限于监管部门、司法机关等）的要求，向其提供您在平台的个人信息和交易记录等必要信息。如您涉嫌侵犯他人合法权益，则平台方有权在初步判断涉嫌侵权行为可能存在的情况下，向权利人提供您必要的个人信息。
              </p>
              <p>
                9.3您同意，平台方有权使用您的注册信息、用户名、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、协助司法机关进行调查取证等。
              </p>
              <p>
                9.4您授权平台方有权留存您在使用本服务过程中提供、发布、形成的相关数据信息并提供给关联公司或政府部门、合作机构，以供后续向您持续性地提供相应服务（包括但不限于将本信息用于向您推广、提供其他更加优质的产品或服务）。您同意平台方使用、复制、修订、编辑、发布、展示、翻译、分发您的上述数据信息，并以已知或日后开发的形式、媒体或技术上将上述数据信息纳入其他作品内。
              </p>
              <p>
                9.5由于平台定位等功能需要，用户在安装、使用平台时，平台方有权获取用户所在的位置信息。
              </p>
              <p>
                9.6您有义务持续确保您在平台所填写及提供的手机号、用户信息、用户信息凭证、验证信息、验证信息凭证等资料、凭证、信息的真实性、准确性、完整性、对应一致性及有效性。若您注册账号的手机号所认证的身份证号、姓名并非手机通信运营商实名认证一致的身份证号、姓名（“实名身份信息”），则您应立即将认证的身份证号和姓名修改为实名身份信息，否则平台方有权限制或停止向您提供部分或全部平台服务或限制您平台账户的部分或全部功能，平台方对此不承担任何责任，您将承担因此而产生的全部直接或间接损失，同时，您还应当赔偿平台方及/或任何其他第三方因此遭受的全部损失。
              </p>
              <p>
                9.7为使您更安全、便捷、全面地使用本服务，平台有权向您发送与本服务有关的信息，如果您不愿意接收此类信息，则您有权通过平台提供的相应的退订方式进行退订。
              </p>
              <p>
                9.8为更好地为您提供本服务，平台方将不时进行平台的维护和升级。您同意，届时平台方仅须提前在平台发布公告即可，系统维护及升级过程中产生的业务中断或不稳定状态，不视为平台方违约。
              </p>
              <p>
                9.9为更好地为您提供本服务，平台方有可能修改本协议项下业务的相关规则。您同意，届时平台方仅须提前在平台发布公告即可，您自愿接受本协议及平台不时发布的新规则的约束。
              </p>
            </div>
            <div className='block'>
              <p className='title'>十、免责条款</p>
              <p>
                10.1平台方仅提供本服务，并不参与具体的商品或服务交易，您使用本服务时，因商品或服务交易本身以及您与任何第三方所产生的任何纠纷或责任，应由您自行解决并承担全部责任。
              </p>
              <p>
                10.2本服务是在现有技术水平下提供的，平台方将尽力为您提供服务，但无法保证该服务完全符合您的预期。
              </p>
              <p>10.3不可抗力</p>
              <p>
                由于不可抗力或意外事件而影响平台提供正常的服务和技术支持时，平台方不承担任何责任。“不可抗力”是指不能预见、不能克服且无法避免的客观事件，如战争、自然灾害、疫情、政府规范修订、黑客攻击等；“意外事件”指诸如光缆出现故障的影响或损坏；通信线路或服务器发生超出平台方防范与预见能力的故障等类似事件。对以下情形导致的本服务中断或受阻，不视为平台方违约，平台方不承担责任：
              </p>
              <p>（1）电信设备出现故障、公共网络故障；</p>
              <p>（2）平台受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
              <p>（3）电信部门及/或平台运营所依赖的其他有关部门、机构出现调整或故障；</p>
              <p>（4）国家相关主管部门颁布、变更法令、政策；</p>
              <p>（5）您或平台方的电脑软件、系统、硬件和通信线路出现故障；</p>
              <p>（6）其他不可抗力因素。</p>
              <p>10.4您在使用本服务的过程中，平台方不对下列风险担责：</p>
              <p>（1）您操作不当；</p>
              <p>（2）您通过非平台方授权的方式使用本服务；</p>
              <p>（3）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</p>
              <p>（4）遭受他人误导、欺骗或其他导致任何心理、生理上的伤害以及经济上的损失；</p>
              <p>（5）其他因网络信息或您行为引起的风险。</p>
              <p>
                10.5平台所提供的定位和轨迹功能，是采用运营商的基站位置信息，由于通信信号等多种因素，平台方不保证用户使用的连贯性以及位置精准性。
              </p>
              <p>
                10.6您在使用本服务的过程中，平台方在法律规定的范围内可处理违法违规内容，但其不构成平台方的义务或承诺。
              </p>
              <p>
                10.7为了改善用户体验、修复漏洞、保障安全性等考虑，平台方有权对软件进行更新，您应该将相关软件更新至最新版本，否则平台方将不保证您能正常使用相关软件。如果您从未经平台方授权的第三方获取软件，平台方无法保证该软件能够正常使用，由此造成的相关损失，平台方不予负责。
              </p>
            </div>
            <div className='block'>
              <p className='title'>十一、隐私保护</p>
              <p>
                11.1平台重视对您个人信息的保护，您的个人信息依平台《隐私政策》受到保护与规范，详情请参阅平台《隐私政策》。《隐私政策》构成本协议不可分割的组成部分，共同适用于您所使用的平台服务。
              </p>
            </div>
            <div className='block'>
              <p className='title'>十二、知识产权保护</p>
              <p>
                12.1平台方在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归平台方及其关联公司所有。
              </p>
              <p>
                12.2除另有特别声明外，平台方提供本服务时所依托软件的著作权、专利权及其他知识产权均归平台方及其关联公司所有。
              </p>
              <p>
                12.3平台方在本服务中所使用的平台名称等商业标识，其著作权、商标权归平台方及其关联公司所有。
              </p>
              <p>
                12.4上述知识产权均受到法律保护，未经平台方或相关权利人书面许可，您承诺不应且不应允许或协助任何人以任何形式（包括但不限于通过任何机器人、蜘蛛、截屏等程序或设备）进行使用、出租、出借、分发、展示、复制、修改、链接、转载、汇编、发表、出版、抓取、监视、引用或创造相关衍生作品。
              </p>
              <p>
                12.5您理解并同意，您在使用平台提供的服务时上传、提交、存储或发布的内容（包括但不限于文字、图片、视频、音频、动画等）的知识产权归属您或您已获合法授权，您的上传、提交、存储或发布行为不会侵犯他人的知识产权或其他合法权益。如果任何第三方提出关于知识产权的异议，平台方有权根据实际情况删除相关的内容，且有权追究您法律责任，给平台方或任何第三方造成损失的，用户应负责全额赔偿。
              </p>
              <p>
                12.6您同意将您在使用平台提供的服务时上传、提交或发布的内容授予平台方永久的、免费的、不可撤销的、非独家的使用许可以及完整的再许可权利；平台方有权使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示该内容的整体或部分，及/或将该内容用于任何平台相关的软件或服务上。您进一步同意，平台方有权以其名义独立或委托第三方针对侵犯以上权利的行为采取任何必要的法律行动，包括但不限于民事诉讼、行政投诉、平台投诉等，并获得依据中华人民共和国法律可获得的所有救济。
              </p>
            </div>
            <div className='block'>
              <p className='title'>十三、其他</p>
              <p>
                13.1您同意，平台方有权根据您的风险程度及自身业务运营情况需要随时中止或终止向您提供本服务，或调整本协议项下业务有关的规则。
              </p>
              <p>
                13.2您确认，一旦您违反本协议及/或平台其他规则、规范，平台方有权根据相应规则对您违约发布的信息进行删除、屏蔽处理，有权依据本协议的约定终止对您的服务，查封您的账户，并有权通知合作机构，暂停对您提供有关服务。平台方可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在平台上予以公示。
              </p>
              <p>
                13.3您同意，用户账户的暂停、中断或终止不代表责任的终止，您仍应对使用平台服务期间的行为承担可能的违约或损害赔偿责任，同时平台方仍可保有用户的相关信息。
              </p>
              <p>
                13.4因您违反本协议及/或平台其他规则、规范约定造成平台方损失的，您应赔偿相应的损失（包括但不限于直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失）。如您的行为使平台方遭受第三人主张权利，平台方可在对第三人承担金钱给付等义务后就全部损失向您追偿。如因您的行为使得第三人遭受损失或您怠于履行调处决定，平台方出于社会公共利益保护或其他善意第三方保护目的，可在符合法律规定的前提下，自您的账户中划扣相应款项进行支付。
              </p>
              <p>13.5本协议自您按本协议文首列明的方式确认接受本协议之日起生效。</p>
              <p>
                13.6您同意，本协议的签订、效力、履行、终止及其解释适用中华人民共和国（为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区）的法律。
              </p>
              <p>
                13.7因平台方与您就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，平台方和您均同意由平台方住所地有管辖权的法院通过诉讼解决。
              </p>
              <p>
                13.8本协议内容包括协议正文、《隐私政策》及平台所有已经发布的或将来可能发布的平台服务使用规则。所有规则为本协议不可分割的一部分，与本协议正文具有相同法律效力。由于互联网高速发展，您与平台方签署的本协议列明的条款并不能完整罗列并覆盖您与平台方之间的所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，平台方通过平台发布的声明及政策、规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用或继续使用平台服务，视为您同意上述补充协议。
              </p>
              <p>
                13.9根据国家法律法规变化及运营需要，平台方有权对本协议条款及其他平台规则、规范不时地进行修改，并通过在平台移动客户端或PC端上发出公告、站内信等合理、醒目的方式向您进行提前通知，上述修改更新内容将在相关更新说明中指定的日期开始实施，通常情况下不短于发布之日后七个自然日。您应当及时查阅并了解相关更新修改内容，如您不同意相关更新修改内容，可停止使用相关更新修改内容所涉及的服务，此情形下，变更事项对您不产生效力；如您在上述更新修改内容实施后继续使用所涉及的服务，将视为您已同意各项更新修改内容。
              </p>
              <p>
                13.10就您在平台上确认、同意的协议、规则、政策、文档等（统称“协议文件”），您同意平台方将协议文件置于电子签约平台以数据电文形式在线签署并储存，并将您的个人信息（姓名、身份证号、手机号、银行卡号、电子邮箱地址及其他身份认证信息）报送给电子签约平台用于电子签名认证并生成数字证书，您特此委托电子签约平台托管并调用您的数字证书代您签署协议文件。您认可由平台方将协议文件的内容发送到电子签约平台生成签约文本。协议文件使用的电子签约平台为可合法有效提供电子签约服务的平台。您同意平台方向电子签约平台调取协议文件、您的签约信息、您的身份认证信息及与证明协议文件有效性、您的电子签名有效性相关的其他信息。
              </p>
              <p>
                13.11如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
              </p>
              <p>13.12本协议未尽事宜，您需遵守平台实时公布的规则。</p>
              <p>
                13.13平台方有权通过您提供的联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您发送系统消息以及站内信信息，平台方可任意选择其中一种方式对您发出通知，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。上述送达方式同样可适用于相关仲裁或司法程序（含起诉、审理、执行等各阶段），司法机关（如人民法院等）可以以短信、微信、电子邮件、平台发送通知/公告等现代通讯工具或邮寄方式向您送达法律文书（包括但不限于受理通知书、判决书、裁定书等诉讼文书）。您应当保证所提供的联系方式是准确、有效的，并进行适时更新，如因提供的联系方式不准确或怠于更新等不可归责于平台方的原因，导致相关通知、文件、文书无法送达或及时送达，您将自行承担由此可能产生的法律后果。
              </p>
              <p>
                13.14本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
              </p>
              <p>
                13.15本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
              </p>
              <p>
                13.16如您对本协议内容或在使用本服务过程中有任何疑问，或存在任何投诉举报需求，您可以通过平台上提供的联系方式、在线客服系统或拨打客服电话（4000-711-718）与我们联系并作充分描述。
              </p>
            </div>
          </div>
          <div className='agreenBtn'>
            <span onClick={this.props.onOk}>同意</span>
          </div>
        </div>
      </Modal>
    )
  }

}

export default ServiceAgreement
